<template>
    <div class="forsakringsbolag">
        <admin-lock-border />
        <modal-basic ref="dialog" />
        <h2>{{ props.parameters.redigera ? "Redigera försäkringsbolag" : "Skapa nytt försäkringsbolag" }}</h2>
        <FormulateForm v-model="formData" @submit="submit" :errors="inputErrors" class="form">
            <div class="grid-container">
                <FormulateInput type="text" name="namn" label="Namn" validation="required" />
            </div>
            <div class="grid-container">
                <FormulateInput type="number" name="ordning" label="Ordning" />
            </div>
            <ButtonGroup>
                <CustomButton type="submit">
                    <span>{{
                        props.parameters.redigera ? "Redigera försäkringsbolag" : "Skapa nytt försäkringsbolag"
                    }}</span>
                </CustomButton>
                <CustomButton @click.prevent="cancelForm" size="slim" variant="contour">
                    <span>Avbryt</span>
                </CustomButton>
            </ButtonGroup>
        </FormulateForm>
    </div>
</template>

<script>
    import tabIcon from "@/assets/receptforskrivning.svg";
    /* TODO: Ändra den här komponenten så att den använder KForm istället */
    export default {
        name: "ForsakringsbolagForm",
        tabName: "Försäkringsbolag",
        icon: tabIcon,
    };
</script>

<script setup>
    import { ref, useAttrs, toRefs, computed } from "vue";
    import emitter from "tiny-emitter/instance";

    import ModalBasic, { BasicModalVariant } from "@/components/generic/ModalBasic.vue";
    import { getConfig, klinikenApi } from "@/api";
    import AdminLockBorder from "@/components/AdminLockBorder.vue";
    import { flashMessage, openDialog } from "@/utils";
    import CustomButton from "@/components/Button.vue";
    import ButtonGroup from "@/components/ButtonGroup.vue";
    import store from "@/store";

    const attrs = useAttrs();

    const props = defineProps({
        parameters: Object,
    });

    const { parameters } = toRefs(props);

    const formData = ref(parameters.value?.forsakringsbolag ?? {});
    const defaultFormData = ref(formData.value);
    const dialog = ref();
    const inputErrors = ref({});

    const cancelForm = async () => {
        if (!formIsChanged.value) {
            store.dispatch("tabs/closeTab", attrs["tab-id"]);

            return;
        }

        emitter.emit("open-dialog", {
            type: "warning",
            description: "Du har osparad data. Vill du stänga utan att spara?",
            buttons: [
                {
                    title: "Fortsätt redigera",
                    type: "secondary",
                },
                {
                    title: "Ja, stäng utan att spara",
                    type: "primary",
                    action: () => {
                        store.dispatch("tabs/closeTab", attrs["tab-id"]);
                    },
                },
            ],
        });
    };

    const formIsChanged = computed(() => {
        return JSON.stringify(formData.value) !== JSON.stringify(defaultFormData.value);
    });

    const submit = async (data) => {
        const id = parameters.value?.forsakringsbolag?.id ?? undefined;
        const url = id ? `/core/forsakringsbolag/${id}/` : "/core/forsakringsbolag/";

        let response = {};

        try {
            if (id) {
                response = await klinikenApi.put(url, data, getConfig());
            } else {
                response = await klinikenApi.post(url, data, getConfig());
            }

            if (response.status === 201 || response.status === 200) {
                flashMessage(response.status === 201 ? "Försäkringsbolag skapad" : "Försäkringsbolag redigerad", 3000);
                emitter.emit("refreshForsakringsbolag");

                await store.dispatch("tabs/closeTab", attrs["tab-id"]);
            } else {
                openDialog("Ett oväntat fel har uppstått. Om felet kvarstår, kontakta supporten.", 3000);
            }
        } catch (error) {
            inputErrors.value = error.response.data;
            openDialog(
                id
                    ? "Något gick fel, kunde inte uppdatera försäkringsbolag. "
                    : "Något gick fel, kunde inte skapa försäkringsbolag",
                "warning"
            );
        }
    };
</script>
<style lang="scss">
    .forsakringsbolag {
        .form {
            .grid-container {
                display: grid;
                grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
                gap: 10px;
            }
        }
    }
</style>
